/**
 * Helper to format a raw WhatsApp value (URL or phone number) into a
 * `https://wa.me/<digits>` URL. Returns the original value when it
 * already looks like a wa.me URL. Returns null for empty input.
 *
 * Phase E split (May 6, 2026): extracted from `LandingPage.jsx` so it
 * can be shared with future features (e.g., admin contact preview).
 */
export const formatWhatsAppUrl = (url) => {
  if (!url) return null;
  if (url.startsWith('https://wa.me/') || url.startsWith('http://wa.me/')) {
    return url;
  }
  const phoneNumber = url.replace(/[^0-9+]/g, '');
  if (phoneNumber) {
    return `https://wa.me/${phoneNumber.replace('+', '')}`;
  }
  return url;
};
